import './StateLabel-b586b0bc.css';

var classes = {"StateLabel":"prc-StateLabel-StateLabel-ukDwa","Icon":"prc-StateLabel-Icon-NuDm4"};

export { classes as default };
